// src/assets/api/Restapi.js
import axios from "axios";

// Create Axios instance for all API calls
const api = axios.create({
  // Laravel is hosted under /api, and routes inside api.php already prefix /api
  // So the full path becomes https://sparklabpk.com/api/api/{endpoint}
  baseURL: "https://sparklabpk.com/api/api",

  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },

  // If you ever use Laravel Sanctum or login cookies later, switch this to true
    withCredentials: false,
});

// --- Optional: Add interceptors for debugging / error handling ---
api.interceptors.request.use(
  (config) => {
    // console.log("[Request]", config);
    return config;
  },
  (error) => {
    console.error("[Request Error]", error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // You can show a global toast or log the error here
    console.error("[API Error]", error?.response || error);
    return Promise.reject(error);
  }
);

export default api;
